import script from "./YoutubeVideo.vue?vue&type=script&lang=ts&setup=true"
export * from "./YoutubeVideo.vue?vue&type=script&lang=ts&setup=true"

import "./YoutubeVideo.vue?vue&type=style&index=0&id=65a4c280&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65a4c280"]])

export default __exports__